import keyMirror from 'keymirror';

export default keyMirror({
  SELECT_RESOURCE: null,
  SELECT_AVAILABLE_TIME: null,
  SELECT_ADDON: null
});
